<template>
    <section>
        <ui-breadcrumb title="Send Subscription Message" :items="['Projects', 'SMS', 'Subscription', 'Send']"></ui-breadcrumb>
        <div class="content">
            <form class="mb-5" action="" method="POST" @submit.prevent="postData">
                <div class="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
                    <div class="row">
                        <div class="col-lg-12 pb-1">

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <label>Send At</label>
                            <div class="form-group">
                                <el-date-picker
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    ref="picker"
                                    size="large"
                                    proper-class="form-control"
                                    v-model="message.sendAt"
                                    type="datetime"
                                    placeholder="Select date and time"
                                    default-time="12:00:00">
                                </el-date-picker>
                                <div v-if="formErrors.sendAt" :class="['text-danger']">
                                    <small>{{formErrors.sendAt[0]}}</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="sender-id">From</label>
                                <v-select :class="{'is-invalid': formErrors.from}"
                                          v-model="message.from"
                                          id="sender-id"
                                          label="senderName"
                                          @input="handleSelectedFrom"
                                          :reduce="option => option.id"
                                          :options="shortCodes">
                                </v-select>
                                <div v-if="formErrors.from" :class="['invalid-feedback']">
                                    {{formErrors.from[0]}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="message.messageType === 'premium'">
                        <div class="col-lg-6">
                            <label>Stop Retries At</label>
                            <div class="form-group">
                                <el-date-picker
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    ref="picker-2"
                                    :picker-options="pickerOptions"
                                    size="large"
                                    proper-class="form-control"
                                    v-model="message.stopRetryAt"
                                    type="datetime"
                                    placeholder="Select date and time"
                                    default-time="23:30:00">
                                </el-date-picker>
                                <div v-if="formErrors.stopRetryAt" :class="['text-danger']">
                                    <small> {{formErrors.stopRetryAt[0]}} </small>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <label for="product">Subscription Service</label>
                            <div class="form-group">
                                <select :class="{'is-invalid': formErrors.service}" id="product" class="form-control" v-model="message.service" >
                                    <optgroup label="SMS Products">
                                        <option v-for="(product, index) in smsProducts" :key="index" :value="product.id">{{product.name}}</option>
                                    </optgroup>
                                </select>
                                <div v-if="formErrors.service" :class="['invalid-feedback']">
                                    {{formErrors.service[0]}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label for="message">Text Message</label>
                                <textarea  :class="{'is-invalid': formErrors.message}" @blur="countCharacters" @keyup="countCharacters" id="message"
                                           class="form-control" v-model="message.message" rows="4"
                                           placeholder="Compose your message"></textarea>
                                <span class='float-right text-right pt-1 pb-3 text-muted' :class="{'font-w700': messageCount > 1}">
                                    <small class="font-italic">{{messageCount}} Message(s) | {{remainingCount}}
                                        Characters Remaining
                                    </small>
                                </span>
                                <div v-if="formErrors.message" :class="['invalid-feedback']">
                                    {{formErrors.message[0]}}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group float-right">
                                <button type="submit" :class="['btn', 'btn-hero', 'btn-outline-success']">
                                    <span class="si si-control-play mr-2"></span>
                                    Send Message
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import VueTelInput from 'vue-tel-input';
    import * as moment from 'moment';
    import ShortCodeApi from '../../api/shortcodes';
    import VueSelect from 'vue-select';

    export default {
        name: "SendSubscriptionMessage",
        components: {
            'vue-tel-input': VueTelInput,
            'v-select': VueSelect
        },
        data() {
            let $this = this;
            return {
                shortCodes: [],
                formErrors: [],
                hasError: false,
                messageCount: 1,
                remainingCount: 160,
                disabledDates: [],
                pickerOptions: {
                    disabledDate(time) {
                        time = moment(time).format('YYYY-MM-DD');
                        return $this.disabledDates.indexOf(time) > -1;
                    }
                },
                smsProducts:[],
                message: {
                    from: '',
                    service: '',
                    sendAt: '',
                    message: '',
                    stopRetryAt: '',
                    messageType: 'premium'
                }
            }
        },
        beforeMount() {
            this.loadShortCodes();
        },
        methods: {
            handleFile(name, $file) {
                if($file[0] instanceof File) {
                    this.message.customFile = $file[0];
                }
            },

            handleSelectedFrom() {
                this.loadShortCodes();
                if(this.message.messageType === 'premium' && '' !== this.message.from) {
                    ShortCodeApi.getShortCode({
                        id: this.message.from,
                        project: this.$route.params.project
                    }).then(shortCode => {
                        this.smsProducts = shortCode.services.data;
                    })
                } else {
                    this.smsProducts = [];
                }
            },

            loadShortCodes() {
                ShortCodeApi.getAllProjectShortCodes({
                    project: this.$route.params.project,
                    service: this.message.messageType
                }).then(result => this.shortCodes = result);
            },

            postData () {
                let project = this.$route.params.project;
                this.formErrors = [];
                axios.post(`web/projects/${project}/sms/subscription/send`, this.message).then(response => {
                    this.$notify({
                        message: 'Message has been queued for dispatch',
                        title: 'Operation successful',
                        type: 'success'
                    });
                    this.$router.push(`/projects/${project}/overview`);
                }).catch((error) => {
                    if(error.response && error.response.status === 422) {
                        this.formErrors = error.response.data.errors;
                        this.hasError = true;
                    }
                })
            },

            countCharacters() {
                let count = Math.ceil(((this.message.message.length) / 160));
                this.messageCount = count === 0 ? 1 : count;
                this.remainingCount = 160 * this.messageCount - this.message.message.length;
            },
        }
    }
</script>

<style scoped>
    .el-date-editor.el-input {
        width: 100% !important;
    }

    .el-input__suffix .el-input__icon {
        padding: 0 !important;
    }
</style>
